export default "__VITE_ASSET__Cb54dLTO__"